import doctorsActionTypes from './action-types';

export const fetchDoctorsList = payload => ({
  type: doctorsActionTypes.FETCH_DOCTORS_LIST,
  payload,
});

export const fetchDoctorsListSuccess = payload => ({
  type: doctorsActionTypes.FETCH_DOCTORS_LIST_SUCCESS,
  payload,
});

export const fetchDoctorsListFail = payload => ({
  type: doctorsActionTypes.FETCH_DOCTORS_LIST_FAIL,
  payload,
});

export const fetchUpdateDoctorLicenceStatus = payload => ({
  type: doctorsActionTypes.FETCH_UPDATE_DOCTOR_LICENCE_STATUS,
  payload,
});

export const fetchUpdateDoctorLicenceStatusSuccess = payload => ({
  type: doctorsActionTypes.FETCH_UPDATE_DOCTOR_LICENCE_STATUS_SUCCESS,
  payload,
});

export const fetchUpdateDoctorLicenceStatusFail = payload => ({
  type: doctorsActionTypes.FETCH_UPDATE_DOCTOR_LICENCE_STATUS_FAIL,
  payload,
});

export const fetchAssignOrRevokeDoctorBadges = payload => ({
  type: doctorsActionTypes.FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES,
  payload,
});

export const fetchAssignOrRevokeDoctorBadgesSuccess = payload => ({
  type: doctorsActionTypes.FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES_SUCCESS,
  payload,
});

export const fetchAssignOrRevokeDoctorBadgesFail = payload => ({
  type: doctorsActionTypes.FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES_FAIL,
  payload,
});
